// extracted by mini-css-extract-plugin
export var root = "SizeList-module--root--0Ydyw";
export var sizeLabelContainer = "SizeList-module--sizeLabelContainer--IQmVY";
export var sizeSelection = "SizeList-module--sizeSelection--RWVZB";
export var guide = "SizeList-module--guide--uTXgx";
export var label = "SizeList-module--label--RIgSh";